export default {
  'reportStock.ABCAnalysis.navigation.title': 'Reports',
  'reportStock.ABCAnalysis.navigation.subtitle': 'Stock',

  'reportStock.ABCAnalysis.tab.abcAnalysis': 'ABC Analysis',

  'reportStock.ABCAnalysis.label.report': 'Select report type',
  'reportStock.ABCAnalysis.label.importance': 'Classification by importance',
  'reportStock.ABCAnalysis.label.download': 'View reports as:',

  'reportStock.ABCAnalysis.radio.part': 'Part',
  'reportStock.ABCAnalysis.radio.service': 'Service',
  'reportStock.ABCAnalysis.radio.customer': 'Customer',
  'reportStock.ABCAnalysis.radio.quantity': 'Quantity',
  'reportStock.ABCAnalysis.radio.value': 'Value',

  'reportStock.ABCAnalysis.actions.viewReport': 'View report',
  'reportStock.ABCAnalysis.actions.generatePDF': 'Generate PDF report',
  'reportStock.ABCAnalysis.actions.generateRTF': 'Generate RTF report',
};
